import { render, staticRenderFns } from "./CompanyGroups.vue?vue&type=template&id=d0528cac&scoped=true"
import script from "./CompanyGroups.vue?vue&type=script&lang=js"
export * from "./CompanyGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0528cac",
  null
  
)

export default component.exports